// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".step4XiaoHsCom[data-v-f260d07a] .el-tabs__item {\n  height: 46px;\n  line-height: 46px;\n}\n.step4XiaoHsCom[data-v-f260d07a] .el-select {\n  flex: 1;\n}\n.step4XiaoHsCom .tab-header[data-v-f260d07a] {\n  display: flex;\n  padding: 16px 75px 32px;\n  justify-content: center;\n}\n.step4XiaoHsCom .tab-bottom[data-v-f260d07a] {\n  padding: 0 40px;\n}\n.icon-company-box[data-v-f260d07a] {\n  width: 35px;\n  height: 35px;\n}\n", ""]);
// Exports
module.exports = exports;
